import { Select } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { useState } from 'react';
import { FormItem } from '../FormItem';
import styles from '../Input/Input.module.scss';
import cn from 'classnames';

export type TOption = { value: string; label: string };

interface MultySelectI {
  name: string;
  label?: string;
  size?: SizeType;
  errorMessage?: string;
  options: TOption[];
  placeholder?: string;
  defaultValue?: string[];
}

const CustomSelect = ({
  errorMessage,
  label = '',
  name,
  size = 'middle',
  options,
  placeholder,
}: MultySelectI) => {
  const [selectedItems, setSelectedItems] = useState<TOption[]>([]);

  const filteredOptions = options.filter(o => !selectedItems.includes(o));

  return (
    <div className={cn(styles.wrapper, { [styles.wrapper_withLabel]: label })}>
      <div>{label}:</div>
      <FormItem message={errorMessage} name={name}>
        <Select
          mode="multiple"
          placeholder={placeholder}
          value={selectedItems}
          onChange={setSelectedItems}
          style={{ width: '100%' }}
          options={filteredOptions.map(item => ({
            value: item.value,
            label: item.label,
          }))}
          size={size}
        />
      </FormItem>
    </div>
  );
};

export default CustomSelect;
